<template>
  <div>
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
        <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
          Add New Address
        </h3>
        <div class="mt-2">
          <p class="text-sm leading-5 text-gray-500">
            Add an address to which your items are to be delivered to.
          </p>
        </div>
      </div>
    </div>

    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
      <div class="sm:col-span-3">
        <label for="location" class="block text-sm font-medium leading-5 text-gray-700">
          Location
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <select disabled :class="{'error': errors.location}" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
            <option v-for="(locationName,key) in config.locations" :value="key" :selected="form.location === key">{{ locationName }}</option>
          </select>
        </div>
        <div v-if="errors.location" class="form-error text-xs">{{ errors.location[0]}}</div>
      </div>

      <div class="sm:col-span-3">
        <label for="contact_number" class="block text-sm font-medium leading-5 text-gray-700">
          Contact Number
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input v-model="form.contact_number" id="contact_number" :class="{'error': errors.contact_number}" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
        </div>
        <div class="form-error text-xs" v-if="errors.contact_number">{{ errors.contact_number[0] }}</div>
      </div>

      <div v-if="form.location !== 'island'" class="sm:col-span-4">
        <label for="address" class="block text-sm font-medium leading-5 text-gray-700">
          Street Address
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input v-model="form.address" id="address" type="text" :class="{'error': errors.address}" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
        </div>
        <div class="form-error text-xs" v-if="errors.address">{{ errors.address[0] }}</div>
      </div>

      <template v-else>
      <div  class="sm:col-span-3">
        <label for="vessel_location" class="block text-sm font-medium leading-5 text-gray-700">
          Vessel Location
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <select v-model="form.vessel_location" id="vessel_location" :class="{'error': errors.vessel_location}" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
            <option v-for="location in config.vessel_locations[form.location]" :value="location">{{ location }}</option>
          </select>
        </div>
        <div class="form-error text-xs" v-if="errors.vessel_location">{{ errors.vessel_location[0] }}</div>
      </div>

        <div  class="sm:col-span-3">
          <label for="vessel_details" class="block text-sm font-medium leading-5 text-gray-700">
            Vessel Details
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input v-model="form.vessel_details" id="vessel_details" type="text" :class="errors.vessel_details" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
          </div>
          <div class="form-error text-xs" v-if="errors.vessel_details">{{ errors.vessel_details[0] }}</div>
        </div>
      </template>

      <div v-if="form.remarks !== 'island'" class="sm:col-span-4">
        <label for="address" class="block text-sm font-medium leading-5 text-gray-700">
          Remarks
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <textarea v-model="form.remarks" id="remarks" type="text" :class="{'error': errors.remarks}" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"></textarea>
        </div>
        <div class="form-error text-xs" v-if="errors.remarks">{{ errors.remarks[0] }}</div>
      </div>
    </div>

    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <loading-button :loading="loading" type="button" class="btn-primary" @click="saveAddress">
          Save
        </loading-button>
      </span>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button type="button" @click="$emit('close-modal')" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
          Cancel
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
export default {
  name: 'AddressForm',
  components: {LoadingButton, Icon},

  props: {
    accountId: {
      type: Number
    },
    location: String,
    config: {
      type: Object,
    },
    url: String
  },

  data() {
    return {
      errors: {},
      loading: false,
      form: {
        location: this.location,
        contact_number: null,
        address: null,
        vessel_location: null,
        vessel_details: null,
        remarks: null,
      }
    }
  },

  methods: {
    saveAddress() {
      this.errors = {}
      this.loading = true
      this.$http.post(this.url, this.form)
      .then(response => {
        this.loading = false
        this.$emit('input', response.data)
      })
      .catch(error => {
        this.loading = false

        if (error.response.status === 422) {
          this.errors = error.response.data.errors
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
